<template>
  <section class="home-block-plans plans">
    <div class="container">
      <div class="content">
        <div ref="title" class="title">
          <slot name="title">
            <h2>Планировки</h2>
          </slot>
        </div>
        <PlansFilters :rooms-filter="roomsFilter" :flats="flats" />
        <FlatsList :flats="filteredFlats" :limit="7" second-layout-type />
        <div class="home-block-plans__buttons">
          <router-link
            class="home-block-plans__button btn btn-outline"
            :to="{ name: 'PlanSearch' }"
          >
            Показать все
          </router-link>
          <button
            data-popup-with-chats
            class="home-block-plans__button btn btn-default"
            data-popup-with-chats-title="Запросить лучшие предложения"
          >
            Лучшие предложения
          </button>
        </div>
        <BannerCallback />
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import _sortBy from "lodash/sortBy";
import _uniq from "lodash/uniq";
import _map from "lodash/map";
import PlansFilters from "@/components/home/filters/PlansFilters.vue";
import FlatsList from "@/components/FlatsList.vue";
import BannerCallback from "@/components/form/BannerCallback.vue";

export default {
  components: {
    PlansFilters,
    FlatsList,
    BannerCallback,
  },

  inject: ["filterStore"],

  data() {
    return {
      flats: [],
      loading: false,
      roomsFilter: null,
    };
  },

  computed: {
    roomsFilterActive() {
      return this.filterStore.state.filterRooms;
    },

    costFilterActive() {
      return this.filterStore.state.filterCost;
    },

    squareFilterActive() {
      return this.filterStore.state.filterSquare;
    },

    floorFilterActive() {
      return this.filterStore.state.filterFloor;
    },

    featsFilterActive() {
      return this.filterStore.state.filterFeats || [];
    },

    sortFilterActive() {
      return this.filterStore.state.filterSort;
    },

    filteredFlats() {
      let filtered = this.flats.filter(
        (flat) =>
          (!this.roomsFilterActive ||
            this.roomsFilterActive.length === 0 ||
            this.roomsFilterActive.includes(flat.layout.room_count)) &&
          (!this.costFilterActive ||
            (flat.discount_cost >= this.costFilterActive[0] &&
              flat.discount_cost <= this.costFilterActive[1])) &&
          (!this.squareFilterActive ||
            (flat.layout.area >= this.squareFilterActive[0] &&
              flat.layout.area <= this.squareFilterActive[1])) &&
          (!this.floorFilterActive ||
            (flat.floor.number >= this.floorFilterActive[0] &&
              flat.floor.number <= this.floorFilterActive[1])) &&
          (this.featsFilterActive.length === 0 ||
            this.featsFilterActive.every(
              (feature) => flat.properties && flat.properties[feature] === true
            ))
      );

      switch (this.sortFilterActive) {
        case "price_asc":
          filtered = filtered.sort((a, b) => a.discount_cost - b.discount_cost);
          break;
        case "price_desc":
          filtered = filtered.sort((a, b) => b.discount_cost - a.discount_cost);
          break;
        case "area_asc":
          filtered = filtered.sort((a, b) => a.layout.area - b.layout.area);
          break;
        case "area_desc":
          filtered = filtered.sort((a, b) => b.layout.area - a.layout.area);
          break;
        default:
          filtered = filtered.sort((a, b) => a.discount_cost - b.discount_cost);
      }

      const priorityLots = filtered.filter(
        (flat) => flat?.properties?.priority_lot
      );
      const regularLots = filtered.filter(
        (flat) => !flat?.properties?.priority_lot
      );
      filtered = [...priorityLots, ...regularLots];

      return filtered;
    },
  },

  async mounted() {
    await this.fetchFlatsData();
  },

  methods: {
    async fetchFlatsData() {
      try {
        this.loading = true;
        const response = await axios.get(
          this.$endpoint + "building-objects/" + this.$project + "/properties"
        );
        let data = response.data.data;

        data = data.filter(
          (flat) =>
            flat.layout.type === "flat" || flat.layout.type === "apartment"
        );

        data.forEach(function (item) {
          switch (item.layout.room_count) {
            case "S":
              item.layout.room_count = "0";
              break;
            case "E2":
              item.layout.room_count = "2";
              break;
            case "E3":
              item.layout.room_count = "3";
              break;
            case "E4":
              item.layout.room_count = "4";
              break;
            case "E5":
              item.layout.room_count = "5";
              break;
          }
        });

        this.flats = data;
        this.roomsFilter = _sortBy(_uniq(_map(data, "layout.room_count")));
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.home-block-plans {
  margin: 96px 0;
}

.title {
  text-align: center;
  margin-bottom: 80px;
}

.title h2 {
  margin-bottom: 0;
}

.home-block-plans__buttons {
  margin-top: 38px;
  display: flex;
  gap: 10px;
}
@media (max-width: 576px) {
  .home-block-plans__buttons {
    margin-top: 22px;
    flex-direction: column;
  }
  .home-block-plans__button {
    flex: 1;
  }
  .home-block-plans {
    margin: 58px 0 48px 0;
  }
  .title {
    margin-bottom: 44px;
  }
}
</style>
